import {Component} from '@angular/core';

import {GlobalState} from '../../../global.state';

@Component({
  selector: 'ba-content-top',
  styleUrls: ['./baContentTop.scss'],
  templateUrl: './baContentTop.html',
})
export class BaContentTop {

  public activePageTitle:string = '';
  public isHome = false;
  public icon: string = '';

  constructor(private _state:GlobalState) {
    this._state.subscribe('menu.activeLink', (activeLink) => {
      if (activeLink) {
        this.icon = activeLink.icon;
        this.activePageTitle = activeLink.title;
        this.isHome = activeLink.isHome;
      }
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/theme/components/baContentTop/baContentTop.component.ts